import { Component, computed, inject, input } from '@angular/core';
import { DemandeAffiliationStatutBackOffice } from '@lib/models/demande-affiliation/types/demande-statut.type';
import { HabilitationStatut } from '@lib/models/demande-habilitation/types/habilitation-statut.type';
import { DemandeValidationPjStatutBackOffice } from '@lib/models/demande-validation-pj/types/demande-validation-pj-statut.type';
import { DemandeType } from '@lib/models/non-conformite/demande-type.model';
import { OptionsService } from '@lib/services/options/options.service';
import { OuiTagModule } from 'omnium-ui/tag';

@Component({
  selector: 'app-status-tag',
  standalone: true,
  imports: [OuiTagModule],
  templateUrl: './status-tag.component.html',
  styleUrl: './status-tag.component.scss',
})
export class StatusBackOfficeTagComponent {
  private readonly optionsService = inject(OptionsService);

  readonly status = input.required<string>();
  readonly demandeType = input<DemandeType>('affiliation');

  readonly label = computed(() => {
    switch (this.demandeType()) {
      case 'affiliation':
        return this.optionsService.getStatutsBackofficeOptions([
          this.status() as DemandeAffiliationStatutBackOffice,
        ])[0].label;
      case 'habilitation':
        return this.optionsService.getHabilitationStatutOptions([
          this.status() as HabilitationStatut,
        ])[0].label;
      case 'validationPj':
        return this.optionsService.getValidationPjStatutsBackofficeOptions([
          this.status() as DemandeValidationPjStatutBackOffice,
        ])[0].label;
    }
  });
}
